/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function confirm(options, context) {
    var _a;
    var api = 'dd.device.notification.confirm';
    var formatInput = function (input) {
        var _a = input !== null && input !== void 0 ? input : {}, _b = _a.content, content = _b === void 0 ? '' : _b, _c = _a.confirmButtonText, confirmButtonText = _c === void 0 ? '确定' : _c, _d = _a.cancelButtonText, cancelButtonText = _d === void 0 ? '取消' : _d;
        return {
            message: content,
            buttonLabels: [confirmButtonText, cancelButtonText],
        };
    };
    var formatOutput = function (ret) { return ({
        confirm: ret.buttonIndex === 0,
    }); };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput, formatOutput: formatOutput });
}

export { confirm as default };
